module.exports = __webpack_public_path__ + "img/logo-chillogallo.2daee19a.png";